import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfigCardsSelectDropdownComponent as ConfigCardsSelectDropdownComponent } from '../config-cards-select-dropdown/config-cards-select-dropdown.component';

@Component({
    selector: 'app-config-cards-select',
    templateUrl: './config-cards-select.component.html',
    styleUrls: ['./config-cards-select.component.scss'],
})
export class ConfigCardsSelectComponent implements OnInit {
    @Input() label: string;
    @Input() placeholder: string;
    @Input() cardConfig: any;
    @Input() currentLang: string;

    @Input()
    get selected() {
        return this.cardConfig;
    }
    set selected(data) {
        this.cardConfig = data;
    }

    @ViewChild(ConfigCardsSelectDropdownComponent)
    public dropdown: ConfigCardsSelectDropdownComponent;

    @Input() options: any[];
    @Output() selectChange = new EventEmitter();

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.cdr.detectChanges();
    }

    select(option: any) {
        this.selected = option;
        this.selectChange.emit(this.selected);
        this.hideDropdown();
    }

    public toggleDropdown(): void {
        this.dropdown.showing ? this.hideDropdown() : this.showDropdown();
    }

    public showDropdown(): void {
        this.dropdown.show();
    }

    public hideDropdown(): void {
        this.dropdown.hide();
    }

    public onTouched: () => void = () => {};
    public OnChange: () => void = () => {};

    writeValue(obj: any): void {
        this.selected = obj;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
